import { useEffect } from 'react';

import { Spinner } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import ApplyFlexiLoanFormView from './applyFlexiLoanFormView/ApplyFlexiLoanFormView';
import {
    ACTIVATE_APPLY_FLEXI_LOAN,
    DEACTIVATE_APPLY_FLEXI_LOAN
} from './ApplyFlexiLoanView.actions';
import { useTrackPageView } from '../../tracking/pageView';
import { MainSectionWrapper } from '../pageStructure/mainSectionWrapper/MainSectionWrapper';

const mapStateToProps = ({ applyFlexiLoanView }: RootState) => ({
    ready: applyFlexiLoanView.ready
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    activate: () => dispatch({ type: ACTIVATE_APPLY_FLEXI_LOAN }),
    deactivate: () => dispatch({ type: DEACTIVATE_APPLY_FLEXI_LOAN })
});

const ApplyFlexiLoanView = ({
    activate,
    deactivate,
    ready
}: ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>) => {
    useTrackPageView({ name: 'Apply Flexi Loan' });

    useEffect(() => {
        activate();

        return () => {
            deactivate();
        };
    }, [activate, deactivate]);

    return (
        <MainSectionWrapper className="min-h-[calc(100vh-75px)] !p-[1rem]">
            {ready ? <ApplyFlexiLoanFormView /> : <LoadingSpinner />}
        </MainSectionWrapper>
    );
};

const LoadingSpinner = () => (
    <div className="text-center">
        <Spinner />
    </div>
);

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(ApplyFlexiLoanView);
